// extracted by mini-css-extract-plugin
module.exports = {"userEditor":"AdminUserEdit_userEditor__1tRxQ"};